import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Collapse } from 'reactstrap';
import { Band } from 'components/layout';
import JobCompletionForm from './JobCompletionForm';
import { updateJob, getNoticeOfCompletion } from 'api/operationsApi';
import PreviewEmailModal from 'components/common/PreviewEmailModal';
import { isInProgress } from 'util/JobStateHelper';
import Logger from 'util/Logger';
import { isHydrogenCyanide } from '../../../util/TreatmentTypeHelper';
import { useNavigate } from 'react-router-dom';

const JobCompletion = ({ 
  currentJob, 
  contacts, 
  initialValues, 
  jobId, 
  currentState, 
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [showPreviewEmail, setShowPreviewEmail] = useState(false);
  const [noticeOfCompletionEmail, setNoticeOfCompletionEmail] = useState('');
  const navigate = useNavigate();

  const toggleExpand = () => {
    setCollapsed(prevState => !prevState);
  };

  const togglePreviewEmail = () => {
    setShowPreviewEmail(prevState => !prevState);
  };

  const handleGetNoticeOfCompletion = useCallback(() => {
    const request = { ...currentJob, ...initialValues };
    getNoticeOfCompletion(request).then(response => {
      setNoticeOfCompletionEmail(response.data);
      setShowPreviewEmail(true);
    });
  }, [currentJob, initialValues]);

  const sendNoticeOfCompletion = (formValues) => {
    const request = { ...currentJob, ...formValues };

    //console.log('JobCompletion', { currentJob });
    // Example of navigation, commented out the original API call
    updateJob(request).then(() => {
      Logger.success('Notice of Completed Treatment sent');
      navigate('/dashboard/in-progress');
    });
    
  };

  if (isInProgress(currentState)) {
    return (
      <Band>
        <div className="form-section">
          <Container>
            <Row className="align-items-center">
              <Col xs="8">
                {!isHydrogenCyanide(currentJob.treatmentDetails.treatmentTypeId) ? 
                  <h4>Notice of Completion</h4> : 
                  <h4>Confirm Completion</h4>}
              </Col>
            </Row>
            <Collapse isOpen={!collapsed}>
              <JobCompletionForm
                currentJob={currentJob}
                contacts={contacts}
                initialValues={initialValues}
                onSubmit={sendNoticeOfCompletion}
                onPreview={handleGetNoticeOfCompletion}
              />
            </Collapse>
          </Container>
          <PreviewEmailModal
            title="Preview Notice of Completion"
            isOpen={showPreviewEmail}
            toggle={togglePreviewEmail}
            jobId={jobId}
            emailContent={noticeOfCompletionEmail}
          />
        </div>
      </Band>
    );
  }

  return null;
};

JobCompletion.propTypes = {
  currentJob: PropTypes.object.isRequired,
  contacts: PropTypes.array.isRequired,
  initialValues: PropTypes.object.isRequired,
  jobId: PropTypes.string.isRequired,
  currentState: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired
};

export default JobCompletion;
